import createColor from 'color';
import { StyleSheet } from 'aphrodite';
import { media, mixins } from 'consumer-components';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';

const orgColors = deploymentConfig.getOrganizationColors();

const action = orgColors.action;
const actionColorLightness = createColor(action).lightness();

const actionDark = mixins.darken(action, 0.25);
const actionLight = mixins.lighten(action, 0.25);
const actionGrey = mixins.lighten(mixins.desaturate(action, 0.6), 0.3);
const actionDarkGrey = mixins.lighten(mixins.desaturate(action, 0.3), 0.2);

const styles = StyleSheet.create({
  action: {
    fill: action,
  },
  actionAccent: {
    fill: actionColorLightness > 30 ? actionDark : actionLight,
  },
  grey: {
    fill: actionColorLightness > 50 ? actionDarkGrey : actionGrey,
  },
  white: {
    fill: '#FFFFFF',
  },
  login: {
    fill: loginBackgroundDynamicColor,
  },
  width: {
    width: '30%',
    [media.mobileMedium]: {
      width: '27%',
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
});

export default styles;
